import { Injectable } from '@angular/core';

import { TotalsPrefix } from '@cds/betting-offer';
import { EventOption } from '@frontend/sports/betting-offer/feature/model';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';

import { OptionNameStrategy } from './option-name.strategy';

@Injectable({ providedIn: 'root' })
export class SixPackOptionNameStrategy extends OptionNameStrategy {
    constructor(private sitecore: Sitecore) {
        super();
    }

    override getOptionName(option: EventOption): string {
        return option.totalsPrefix
            ? `${this.preFix(option.totalsPrefix)} ${option.marketAttribute}`
            : option.optionAttribute || option.marketAttribute || '';
    }

    private preFix(totalsPrefix: TotalsPrefix): string {
        return totalsPrefix === TotalsPrefix.Over ? this.sitecore.eventGrid.SixPack_TotalsOver : this.sitecore.eventGrid.SixPack_TotalsUnder;
    }
}
